import { AuthScreen } from "../auth/AuthScreen";

/**
 * /sign-up — the shared aurora auth screen in sign-up mode (web and native).
 * All auth mechanics live in auth/AuthScreen + auth/useAuthActions.
 */
const RegisterPage = () => <AuthScreen mode="sign-up" />;

export default RegisterPage;
